module.exports = __webpack_public_path__ + "img/CtrlRoom_QR.a9c9f3ee.png";